export function toTitleCase(string: string): string {
  return string.replace(/\b\w/g, (char) => char.toUpperCase());
}
